import { getNodeEnv } from './env.config';

const serverDomain = {
  production: '/portal/web/api',
  development: '/portal/web/api', // `http://localhost:${getDevPort()}/web/api`,
};

const baseURL = serverDomain[getNodeEnv()];

export {
  baseURL,
};